import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    if (import.meta.env.DEV) {
      console.error('[ErrorBoundary]', error, info.componentStack);
    }
  }

  private reset = () => this.setState({ error: null });

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <section style={{ padding: '120px var(--gutter)' }}>
        <span className="nano">/ ERROR / SIGNAL LOST</span>
        <h1 className="upper tight" style={{ fontSize: 'var(--t-h1)', marginTop: 16 }}>
          TRANSMISSION INTERRUPTED
        </h1>
        <p className="fg-dim" style={{ marginTop: 16, maxWidth: 560 }}>
          {error.message || 'An unexpected error occurred.'}
        </p>
        <button
          type="button"
          className="btn btn-arrow"
          style={{ marginTop: 24 }}
          onClick={this.reset}
        >
          RETRY
        </button>
      </section>
    );
  }
}
